module.exports = __webpack_public_path__ + "media/images/icons/price-pink-32b272e6f619e78689823beee09e6ad4.svg";